module.exports = __webpack_public_path__ + "static/media/bannerChanges.0152b23e.png";